import { setV1Config } from '@host-panel/request/config';

type NewDataToAssign = {
  enabled: boolean;
  counter: number;
};

export async function setAutoPendingConfig(spotId: string, data: NewDataToAssign) {
  return setV1Config(spotId, [
    { key: 'auto_pend_message_reports_enabled', value: data?.enabled },
    { key: 'auto_pend_message_reports_threshold', value: data?.counter }
  ]);
}
